import { Component, OnInit } from '@angular/core';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { LicenseManager } from '../../managers/License.manager';
import { GracePeriodReportItem, GracePeriodReportItemArray } from '../../models/ss-api/responses/grace.period.report.response';
import { UserRolesService } from '../../services/user.roles.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { Angular2Csv } from 'angular2-csv';
import { SortBot } from '../../../app/helpers/sort';

@Component({
    selector: 'grace-period-report',
    templateUrl: './grace.period.report.component.html',
    styleUrls: ['./grace.period.report.component.scss']
})
export class GracePeriodReportComponent implements OnInit {

    // VARIABLES
    IsBusy: boolean = false;

    Report: GracePeriodReportItemArray;

    // Result Filters
    SearchTermIP: string = '';
    SearchTermMAC: string = '';
    SearchTermPC: string = '';

    InitiatingBilling: boolean = false;

    GracePeriodFilter: string;

    // OTHER STUFF

    constructor(private api: ssApiService,
        private gb: GlobalService,
        public roles: UserRolesService,
        private sweetAlert: SweetAlertService) { }

    ngOnInit() {
        this.gb.SetPageTitle('Grace Period Report');
        this.GetGracePeriodReportItems();
    }

    SortBy(sortVar1: string, sortVar2: string = '') {
        this.Report = SortBot.SortAuto(this.Report, sortVar1, sortVar2);
    }

    GetGracePeriodReportItems() {

        this.IsBusy = true;

        let disposable = this.api.GetGracePeriodReport().subscribe(response => {
            disposable.unsubscribe();
            this.Report = response.Data;
            // this.AddTestItems();
            this.IsBusy = false;
        }, error => {
            disposable.unsubscribe();
            this.IsBusy = false;
        });

    }

    AddTestItems() {
        let newItem = new GracePeriodReportItem;
        newItem.Created = new Date();
        newItem.LicenseKey = 'AG123F93Sf9FF))F';
        newItem.MemberFullName = 'Ross Horovitz';
        newItem.MemberID = 18;
        newItem.NextAction = 'nextAction';
        newItem.NextAttemptTriggerDay = 5;
        newItem.TriggerDay = 1;
        newItem.CurrentAction = 'currentAction';
        newItem.NextAttempt = new Date();

        this.Report.push(newItem);
        this.Report.push(newItem);
        this.Report.push(newItem);

    }



    onLicenseClick(LicenseKey: string) {
        this.IsBusy = true;
        let manager = new LicenseManager();
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(LicenseKey, true);
        manager.OnChangesSaveResponse.subscribe(response => {
            this.GetGracePeriodReportItems();
        });
    }

    InitiateBillingProcess() {
        if (this.InitiatingBilling)
            return;

        this.IsBusy = true;
        this.InitiatingBilling = true;

        this.sweetAlert.swal({
            type: 'warning',
            title: 'Are you sure?',
            text: 'This will initiate billing for all members. Please be sure you want to do this.',
            showCancelButton: true
        }).then((response) => {
            this.IsBusy = false;
            this.InitiatingBilling = false;
            let disposable = this.api.ProcessAutomationBilling().subscribe(
                response => {
                    this.sweetAlert.swal({
                        type: 'success',
                        title: 'Billing Initiated',
                        text: 'Billing has been initiated and cannot be reversed.',
                        timer: 1500
                    }).then(() => { }, () => { });
                    this.IsBusy = false;
                    this.InitiatingBilling = false;
                    disposable.unsubscribe();
                },
                error => {
                    this.sweetAlert.swal({
                        type: 'error',
                        title: 'Error',
                        text: 'There was an error initiating the billing process. Please contact Fausto for further information.'
                    }).then(() => { }, () => { });
                    this.IsBusy = false;
                    this.InitiatingBilling = false;
                }
            );
        }, (dismiss) => {
            this.IsBusy = false;
            this.InitiatingBilling = false;
        });
    }

    ExportToCSV() {
        let options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            headers: ['Date', 'Member Name', 'License Key', 'Current Action', 'Last Trigger Event', 'Next Trigger Event', 'Next Action', 'Next Attempt']
        };

        let ExportData = [];

        this.Report.forEach(function (item) {
            ExportData.push({
                Date: item.Created,
                MemberName: item.MemberFullName,
                CDKey: item.LicenseKey,
                CurrentAction: item.CurrentAction,
                LastTriggerEvent: item.TriggerDay,
                NextTriggerEvent: item.NextAttemptTriggerDay,
                NextAction: item.NextAction,
                NextAttempt: item.NextAttempt
            });
        });

        new Angular2Csv(ExportData, 'GracePeriodReport', options);
    }

    RemoveGracePeriod(item) {
        this.sweetAlert.swal({
            type: 'warning',
            title: 'Are You Sure?',
            text: 'This cannot be undone',
            showCancelButton: true,
            preConfirm: () => {
                return this.api.DeleteAutomationBillingActive(item.AutomationBillingActiveID).toPromise();
            }
        }).then((response) => {
            if (response.Result) {
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Removed From Grace Period',
                    timer: 1500
                }).then(() => { this.GetGracePeriodReportItems(); }, () => { this.GetGracePeriodReportItems(); });
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Error',
                    text: response.Message
                });
            }

        }, () => { });
    }

}
